<soft-garage-order-items-form [(items)]="items" [changePriceAndDiscount]="true" #form />
<div class="my-2 gap-2 flex flex-col overflow-y-auto max-h-150">
  @if (items().length === 0) {
    <div class="h-40 items-center flex flex-col justify-center">
      <soft-icon name="fa-regular fa-box-open" class="text-light mx-auto mb-1 text-3xl" />
      <p class="text-center text-light italic text-sm">Noch keine Artikel hinzugefügt.</p>
    </div>
  } @else {
    @for (item of items(); track item.product.id) {
      <soft-garage-order-item-card
        [orderItem]="item"
        (editOrderItem)="form.editItem(item)"
        (removeOrderItem)="form.removeItem(item)"
        [canEdit]="true"
        [canDelete]="true"
      />
    }
  }
</div>
<div class="flex gap-2 mt-2">
  <button
    type="button"
    class="soft-button outline h-14 w-full mt-4"
    (click)="this.resolve(null)"
  >
    Abbrechen
  </button>
  <button
    type="button"
    class="soft-button primary h-14 w-full mt-4"
    (click)="resolve(items())"
    [disabled]="items().length === 0"
  >
    Speichern
  </button>
</div>
